import { Controller } from "@hotwired/stimulus"

// Expand/collapse a panel and optionally rotate a chevron. Replaces the Alpine
// x-data/x-show used for the conversation "communities in common" banner, which
// the production CSP blocks.
//
//   <div data-controller="disclosure">
//     <button data-action="disclosure#toggle">… <svg data-disclosure-target="icon"></svg></button>
//     <div data-disclosure-target="panel" hidden>…</div>
//   </div>
export default class extends Controller {
  static targets = ["panel", "icon"]

  toggle() {
    if (!this.hasPanelTarget) return
    const willOpen = this.panelTarget.hidden
    this.panelTarget.hidden = !willOpen
    if (this.hasIconTarget) {
      this.iconTarget.style.transform = willOpen ? "rotate(180deg)" : ""
    }
  }
}
